export default __webpack_public_path__ + "static/img-4-a28019f58816e707807c4d585d200505.png";